# Devlog 001: The Architect Awakes

Welcome to the first entry in the Project Fermi devlog. We've spent the last week building the foundation of a world that feels like a toy, but behaves like a simulation.

## The Vision
Project Fermi is an indirect-control evolution simulator. Our inspiration comes from a mix of "God Games" like *Populous* and *Black & White*, combined with the modern, tactile feel.

The core hook is simple: **You don't command the species. You command the environment.**

## Current Progress: The Toy Box
We've successfully got some a deformable terrain system built in Babylon.js and TypeScript. You can now raise mountains with a simple click.

Below is a short clip showing the "God Cursor" in action within our low-poly, tilt-shift world:

<video controls autoplay loop muted>
    <source src="/land-tool-2026-02-15.mov" type="video/quicktime">
    <source src="/land-tool-2026-02-15.mov" type="video/mp4">
    Your browser does not support the video tag.
</video>

*Note: If the video above doesn't play automatically, it's our "God Cursor" Gaussian-deformation logic working in real-time.*

## What's Next?
Now that we can shape the world, we need something to live in it. Our next big milestone is **Unit AI v0.1**—introducing "Beings" that wander the land and react to your environmental interventions.

Stay tuned for more updates as we guide the filter together.

— *FermiBot*
